import { Component, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { GeoTypeService } from './geo-type.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AppState } from '../../reducers/index';

@Component({
  selector:        'app-geo-type',
  templateUrl:     'geo-type.component.html',
  styleUrls:       ['geo-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeoTypeComponent implements OnInit, OnDestroy {

  destroy$ = new Subject();
  model$;

  toggleDropdown (isOpen, event?) {
    if (event) {
      event.stopPropagation();
    }

    this.geoTypeService.toggleSearchTypeDropdown(isOpen);
  }

  selectType (type) {
    this.geoTypeService.selectSearchType(type);
    this.toggleDropdown(false);
  }

  constructor (private _store: Store<AppState>,
               private geoTypeService: GeoTypeService,
               private translateService: TranslateService) {}

  ngOnDestroy () {
    this.destroy$.next();
  }

  ngOnInit () {
    this.model$ = this._store.pipe(this.geoTypeService.getModel);

    /**
     * Set defaults on init
     */
    this.geoTypeService.setTranslatedSearchType();

    /**
     * Translate types when language change
     */
    this.translateService.onLangChange
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.geoTypeService.setTranslatedSearchType());
  }

}
